<template>
  <div class="app">
    <SiteHeader/>
    <div class="app-body">
      <main class="main">
        <div class="container">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { SiteHeader, SiteFooter } from '../components/'

export default {
  name: 'site',
  components: {
    SiteHeader,
    SiteFooter
  },
  data () {
    return {
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Site.vue